import React, { useState } from "react";
import { Container, Button } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";

//import * as sortPostsFrontendIcon from "@material-ui/icons/sortPostsFrontend"
import Sort from "@material-ui/icons/Sort"
import Posts from "./posts/posts";
import useStyles from "./styles";

import { sortPosts } from "./../../actions/posts";

const PostContainer = ({ setCurrentId }) =>
{
  //Switches between descending and ascending post order based on rating
  const [descending, setOrder] = useState(true);

  const classes = useStyles();
  const current_posts = useSelector((state) => state.posts);

  const dispatch = useDispatch();

  const sortPostsFrontend = (posts) =>
  {
    dispatch(sortPosts(posts, descending));
    setOrder(!descending);
  }

  return (
    <Container className={classes.posts_container}>
      <Button className={classes.sort_button} variant="outlined" size="medium" color="primary" startIcon={<Sort />} onClick={() => sortPostsFrontend(current_posts)} />
      <Posts setCurrentId={setCurrentId} />
    </Container>
  );
}


export default PostContainer;
